function removeSelection(range) {
  try {
    window.getSelection().removeRange(range)
  } catch (err) {
    window.getSelection().removeAllRanges()
  }
}

function fillSelectionWithRange(node) {
  const range = document.createRange()
  range.selectNode(node)
  window.getSelection().addRange(range)
  return range
}

function copyToClipboard(node) {
  removeSelection()

  const range = fillSelectionWithRange(node)
  document.execCommand("copy")
  removeSelection(range)
}

export default copyToClipboard
